// extracted by mini-css-extract-plugin
module.exports = {"moveTarget":"itemMoveTarget_moveTarget__1Xi0p"};